/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbChatModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbIconModule,
  NbMenuModule,
  NbSelectModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { JwtInterceptor } from "./auth/jwt.interceptor";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "./services/data.service";
import { CoreModule } from "./@core/core.module";
import { CommonDataService } from "./services/common-data.service";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { NgSelectModule } from "@ng-select/ng-select";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

const services = [
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: DataService, useClass: DataService },
  { provide: CommonDataService, useClass: CommonDataService }
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NgbModule,
    NbIconModule,
    NbContextMenuModule,
    NbSelectModule,
    NbSpinnerModule,
    NgxSkeletonLoaderModule,
    NgSelectModule
    
  ],
  bootstrap: [AppComponent],
  providers: [...services, ,DynamicDialogRef,DynamicDialogConfig],
})
export class AppModule {}
